export default {
  slots: {
    identity: {
      label: 'Dokument tożsamości',
      hint: 'Dowód osobisty, paszport lub karta pobytu, przód i tył. Tutaj dodaj też dokumenty wspólników.',
    },
    trade_registration: {
      label: 'Zgłoszenie działalności gospodarczej (Gewerbeanmeldung)',
      hint: 'Zgłoszenie działalności otrzymane z urzędu gospodarczego.',
    },
    commercial_register_extract: {
      label: 'Wyciąg z rejestru handlowego (Handelsregisterauszug)',
      hint: 'Aktualny wyciąg z rejestru handlowego, jeśli Twoja firma jest w nim zarejestrowana.',
    },
    bank_statement: {
      label: 'Wyciąg bankowy (Kontoauszug)',
      hint: 'Niedawny wyciąg z konta firmowego z widocznym posiadaczem konta i numerem IBAN.',
    },
    shareholder_list: {
      label: 'Lista wspólników (Gesellschafterliste)',
      hint: 'Aktualna lista wspólników.',
      hint_gbr: 'Umowa spółki (Gesellschaftsvertrag) lub lista wszystkich wspólników.',
    },
    tax_number: {
      label: 'Numer podatkowy lub NIP UE (Steuernummer oder USt-IdNr.)',
      hint: 'Pismo z urzędu skarbowego z numerem podatkowym lub potwierdzenie numeru VAT UE.',
    },
  },
  tags: {
    required: 'Wymagane',
    optional: 'Opcjonalne',
    missing: 'Brak',
  },
  kinds: {
    passport: 'Paszport',
    driver_license: 'Prawo jazdy',
    id_card: 'Dowód osobisty',
    residence_permit: 'Karta pobytu',
  },
  holders: {
    owner: 'Właściciel',
    partner: 'Wspólnik: {{name}}',
  },
  file: {
    with_back: 'Przód i tył',
    uploaded_at: 'Przesłano {{date}}',
    expires_at: 'Ważny do {{date}}',
  },
  errors: {
    load: 'Nie udało się załadować dokumentów.',
  },
  empty: 'Brak pliku',
  buttons: {
    add: 'Dodaj plik',
    replace: 'Zamień',
    remove: 'Usuń',
    retry: 'Spróbuj ponownie',
  },
  remove_confirm: {
    title: 'Usunąć ten plik?',
    description: 'Użyj tego, jeśli przesłałeś plik przez pomyłkę.',
    ok: 'Usuń',
    cancel: 'Anuluj',
  },
  toasts: {
    remove_success: 'Plik usunięty',
    remove_error: 'Nie udało się usunąć pliku. Spróbuj ponownie.',
  },
};
